
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/new-york",
      function () {
        return require("private-next-pages/medical-card/new-york.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/new-york"])
      });
    }
  